import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {NewsPost} from "../../../data/models/sponsor_api/NewsPost";
import Link from "@mui/material/Link";
import {Theme, useMediaQuery, useTheme} from "@mui/material";
import {useState} from "react";

export default function NewsRow(newsPost: NewsPost) {
    const theme = useTheme();
    const darkMode = theme.palette.mode === 'dark';

    const [isMdOrUp, setIsMdOrUp] = useState(
        useMediaQuery((theme: Theme) => theme.breakpoints.up("md"))
    );

    return (
        <Link key={newsPost.title} href={newsPost.link} m={'10px'} target={"_blank"} rel={"noopener"} sx={{
            textDecoration: 'none',
            width: '100%',
        }}>
            <Grid container sx={{
                direction: "row",
                alignItems: "center",
                display: 'flex',
                flexDirection: isMdOrUp ? 'row' : 'column',
                flexWrap: 'nowrap',
                color: darkMode ? 'white' : 'black',
                padding: 1,
            }}>
                {newsPost.image_link === null ?
                    null :
                    <Grid item xs={isMdOrUp ? 2 : 12} sx={{
                        width: '150px',
                        height: '150px',
                        backgroundImage: `url(${newsPost.image_link})`,
                        backgroundSize: 'cover',
                        marginX: 1,
                    }}/>
                }
                <Grid item xs={isMdOrUp ? 10 : 12} sx={{
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Typography fontWeight={"bold"}>
                        {newsPost.title}
                    </Typography>
                    <Typography>
                        {newsPost.publisher}
                    </Typography>
                    <Typography fontStyle={"italic"}>
                        {new Date(newsPost.publish_date).toDateString()}
                    </Typography>
                </Grid>
            </Grid>
        </Link>
    )
}